import classNames from 'classnames';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Title = styled.h3`
  font: var(--t-bold) var(--t-20);
  color: var(--c-neutral-1000);
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--unit);
  &.loading ${Title} {
    color: var(--c-neutral-400);
  }
  @media ${tabletAndAbove} {
    gap: var(--double-unit);
  }
`;

type Props = {
  children: ReactNode;
  title?: ReactNode;
  loading?: boolean;
};

export const Section = ({ children, title, loading }: Props) => {
  return (
    <Wrapper className={classNames({ loading })}>
      {title && <Title>{title}</Title>}
      {children}
    </Wrapper>
  );
};
